import {
    LIST_JURISDICTIONS,
    LIST_JURISDICTIONS_SUCCESS,
    LIST_JURISDICTIONS_ERROR,
    SELECT_JURISDICTIONS,
    CLOSE_JURISDICTION_LIST,
    CLOSE_JURISDICTION_LIST_ERROR,
    CLOSE_JURISDICTION_LIST_SUCCESS,
    GET_JURISDICTION,
    GET_JURISDICTION_SUCCESS,
    GET_JURISDICTION_ERROR,
    LIST_PROCEEDING_HISTORY,
    LIST_PROCEEDING_HISTORY_SUCCESS,
    LIST_PROCEEDING_HISTORY_ERROR,
    LIST_PROCEEDINGS,
    LIST_PROCEEDINGS_SUCCESS,
    LIST_PROCEEDINGS_ERROR,
    SELECT_HISTORY,
    SELECT_HISTORY_ERROR,
    SELECT_HISTORY_SUCCESS,
    UNSELECT_HISTORY,
    UNSELECT_HISTORY_ERROR,
    UNSELECT_HISTORY_SUCCESS,
    UNSELECT_JURISDICTION,
    UNSELECT_JURISDICTION_SUCCESS,
    UNSELECT_JURISDICTION_ERROR,
    DECODE_URL,
    DECODE_URL_ERROR,
    DECODE_URL_SUCCESS
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    error: null,
    loading: false,
    selectedCenter: null,
    selectedJurisdiction: null,
    proceedings: null,
    searchParams: null,
    page: 1,
    selectedProceeding: null,
    stories: null,
    selectedHistory: null
}

export default function proceedingReducer(state = initialState, action) {
    switch(action.type){
        case LIST_PROCEEDINGS:
        case SELECT_HISTORY:
        case UNSELECT_HISTORY:
        case LIST_JURISDICTIONS:
        case CLOSE_JURISDICTION_LIST:
        case GET_JURISDICTION:
        case UNSELECT_JURISDICTION:
        case DECODE_URL:
            return {
                ...state,
                loading: true
            }
        case LIST_PROCEEDINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                proceedings: action.payload.params.page === 1 ? action.payload.proceedings : (state.proceedings ? [...state.proceedings, ...action.payload.proceedings] : action.payload.proceedings),
                searchParams: action.payload.params
            }
        case LIST_PROCEEDING_HISTORY:
            return {
                ...state,
                loading: true,
                selectedProceeding: action.payload
            }
        case LIST_PROCEEDING_HISTORY_ERROR:
        case LIST_PROCEEDINGS_ERROR:
        case SELECT_HISTORY_ERROR:
        case UNSELECT_HISTORY_ERROR:
        case LIST_JURISDICTIONS_ERROR:
        case CLOSE_JURISDICTION_LIST_ERROR:
        case GET_JURISDICTION_ERROR:
        case UNSELECT_JURISDICTION_ERROR:
        case DECODE_URL_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_PROCEEDING_HISTORY_SUCCESS:
        case DECODE_URL_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                stories: action.payload.stories,
                selectedProceeding: action.payload.proceeding
            }
        case SELECT_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedHistory: action.payload
            }
        case UNSELECT_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedHistory: null
            }
        case UNSELECT_JURISDICTION_SUCCESS:
            return {
                ...initialState
            }
        case LIST_JURISDICTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                selectedCenter: action.payload.center,
                jurisdictions: action.payload.jurisdictions
            }
        case CLOSE_JURISDICTION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCenter: null,
                jurisdictions: null
            }
        case SELECT_JURISDICTIONS:
            return {
                ...state,
                selectedCenter: null,
                selectedJurisdiction: action.payload,
                searchParams: null,
                proceedings: null,
                selectedProceeding: null,
                selectedHistory: null,
                stories: null,
                loading: false
            }
        case GET_JURISDICTION_SUCCESS:
            return {
                ...state,
                selectedCenter: null,
                selectedJurisdiction: action.payload,
                loading: false
            }
        default:
            return state;
    }
}